import Navbar from '../components/cummon/Navbar';

import Footer from '../components/cummon/Footer';

import OSINTHero from '../components/osint/osintHero';

import   AuditTypes from '../components/osint/typeOsint';

import OsintGlobalAudit from '../components/osint/ServicePresentation';

import OsintUseCases from '../components/osint/casUsageOsint';

import DefensivePreventive from '../components/osint/twoOsint';

import ContactCTA from '../components/osint/contactCall';

import OSINTBenefits from '../components/osint/osintBenifites';


import CaseStudies from '../components/osint/CaseStudies';

import OsintCTA from '../components/osint/osintCta';


function Osint() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
        <OSINTHero />
        <OsintGlobalAudit />
        <AuditTypes />
        <OsintUseCases />
        <DefensivePreventive />
        <ContactCTA />
        <OSINTBenefits />
        <CaseStudies />
        <OsintCTA />
      
      <Footer />
      
    
    
    </div>
  );
}

export default Osint;
